export default __webpack_public_path__ + "static/media/mark_2.0a7ba0a1.png";